/* eslint-disable prettier/prettier */
import { NewsFeedProvider } from './newsFeedContext';
import PostInput from './PostInput';
import React from 'react';

interface NewsFeedProps {
  auth?: {
    displayName?: string;
    email?: string;
  };
  onLogout: () => void;
}

const NewsFeed: React.FC<NewsFeedProps> = ({ auth, onLogout }) => {
  return (
    <NewsFeedProvider>
      <PostInput auth={auth} onLogout={onLogout} />
    </NewsFeedProvider>
  );
};

export default NewsFeed;
